import { call, put, takeLeading } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import getNextLesson from 'api/lessons/NextLesson'
import getCourse from 'api/courses/Get'
import { SuccessToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import * as fromCourseActions from '../../actions/courses.action'
import * as fromActions from '../../actions/lessons.action'

async function getNextLessonCourse(lessonId: number) {
  return await getNextLesson(lessonId)
}

async function getCourseInfo(courseId: number) {
  return await getCourse(courseId)
}

export function* getNextLessonEffectSaga(action: any) {
  try {
    const { data } = yield call(getNextLessonCourse, action.payload.lessonId)

    yield put(fromActions.Actions.lesssonGetNextLessonSuccess(data))
    yield put(
      fromCourseActions.Actions.courseReloadCourseProgress(
        action.payload.courseId
      )
    )

    if (action.payload.finishCourse) {
      const dataCourse = yield call(getCourseInfo, action.payload.courseId)
      if (dataCourse.hasCertificates)
        SuccessToast(
          I18n.t(
            `administration.toastMessages.${
              dataCourse.synchronousCourse
                ? 'certificateGenerateSynchronousCourse'
                : 'certificateGenerateSuccess'
            }`
          )
        )

      yield put(push(`/`))
    }
  } catch (error: any) {
    const reason = error?.response?.data?.reason
    if (reason === 'missing_attestation' || reason === 'incomplete_profile') {
      yield put(fromActions.Actions.lesssonGetNextLessonFailure(reason))
      return
    }

    if (
      error?.response?.status === 422 &&
      reason === 'pending_mandatory_evaluation'
    ) {
      yield put(
        fromActions.Actions.lessonsNextLessonRejected({
          lessonId: action.payload.lessonId,
        })
      )
      yield put(
        fromCourseActions.Actions.courseReloadCourseProgress(
          action.payload.courseId
        )
      )
      return
    }

    console.log('error: ', error)
  }
}

export function* getNextLessonWatcherSaga() {
  yield takeLeading(
    fromActions.LESSONS_GET_NEXT_LESSON,
    getNextLessonEffectSaga
  )
}
